import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ChevronIcon({
	width = 16,
	height = 8,
	color = 'currentColor',
	expanded = false,
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 8"
			fill="none"
			aria-hidden="true"
			style={{
				display: 'block',
				aspectRatio: '2 / 1',
				transform: expanded ? 'rotate(180deg)' : 'none',
				transition: 'transform 160ms ease',
				...style
			}}
			{...rest}
		>
			<path d="M1 1.5 L8 6.5 L15 1.5" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
